module.exports = "https://cdn.littlereply.com/tt/resource/icon_likes.c6f0fd89c3106d26858a70baff48932e.png";